import { combineReducers } from "@reduxjs/toolkit";
import {
  patientReducer,
  patientRecordLockingReducer,
  userReducer,
  adminReducer,
  implementationReducer,
  admissionsAdvisorReducer,
  estimatorReducer,
  vobReducer,
  riskAssessmentReducer,
  metaDataReducer,
  paymentContextReducer,
} from "@finpay-development/shared-platform";

// finpass-ui owns its own rootReducer, composed from shared-platform's reducer
// building blocks. Apps construct their own store shape; the package no longer
// dictates the combined reducer (Option A).
const rootReducer = combineReducers({
  patientContext: patientReducer,
  patientRecordLockingContext: patientRecordLockingReducer,
  userContext: userReducer,
  adminContext: adminReducer,
  implementationContext: implementationReducer,
  admissionsAdvisorContext: admissionsAdvisorReducer,
  estimatorContext: estimatorReducer,
  vobContext: vobReducer,
  riskAssessmentContext: riskAssessmentReducer,
  metaData: metaDataReducer,
  paymentContext: paymentContextReducer,
});

export default rootReducer;

// finpass-ui owns its RootState, derived from its own composition. It must
// satisfy shared-platform's RootState contract (the shape the shared code is
// written against); structurally it does, since it's built from the same blocks.
export type RootState = ReturnType<typeof rootReducer>;
